module.exports = __webpack_public_path__ + "img/materializar@x1.3be14e96.png";